import { Mail, Phone } from "lucide-react";
import { Wordmark } from "@/components/site/Wordmark";

const AWARDS = [
  { src: "/award.png", top: "Best Marketing Strategy", bottom: "for Lead Generation" },
  { src: "/award.png", top: "Best Marketing Strategy", bottom: "for Sales" },
  { src: "/award.png", top: "Best Innovative", bottom: "Use of Technologies" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-ink-900 text-white"
    >
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid gap-12 md:grid-cols-12">
          {/* Brand + contact + socials */}
          <div className="md:col-span-5">
            <Wordmark light className="h-[72px]" />
            <p className="mt-5 max-w-sm text-base text-white/60">
              Το απόλυτο εργαλείο πωλήσεων για την Ελλάδα και το εξωτερικό.
            </p>

            <ul className="mt-8 space-y-3 text-base text-white/75">
              <li>
                <a href="mailto:info@videoactive.gr" className="flex items-center gap-3 hover:text-brand-300">
                  <Mail className="h-5 w-5 shrink-0 text-brand-400" />
                  info@videoactive.gr
                </a>
              </li>
              <li>
                <a href="tel:+302102202725" className="flex items-center gap-3 hover:text-brand-300">
                  <Phone className="h-5 w-5 shrink-0 text-brand-400" />
                  +30 210 220 2725
                </a>
              </li>
            </ul>

            {/* Social media hidden until accounts are live.
                To restore: re-add `Instagram, Facebook, Linkedin` to the lucide-react import above.
            <div className="mt-8 flex gap-3">
              {[Instagram, Facebook, Linkedin].map((Icon, i) => (
                <a
                  key={i}
                  href="#contact"
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white/80 transition-colors hover:bg-brand-500 hover:text-white"
                  aria-label="social"
                >
                  <Icon className="h-5 w-5" />
                </a>
              ))}
            </div>
            */}
          </div>

          {/* Awards */}
          <div className="md:col-span-7 md:col-start-6 flex items-center">
            <div className="grid w-full grid-cols-3 gap-4 sm:gap-8">
              {AWARDS.map((a, i) => (
                <div key={i} className="flex flex-col items-center text-center">
                  <img
                    src={a.src}
                    alt={`${a.top} ${a.bottom}`}
                    className="h-40 w-auto sm:h-48"
                    draggable={false}
                  />
                  <span className="mt-4 text-sm leading-snug text-white/80">
                    {a.top}
                    <br />
                    <strong className="font-bold text-white">{a.bottom}</strong>
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-7 text-sm text-white/40 sm:flex-row">
          <span>© {new Date().getFullYear()} VideoActive</span>
          <span>
            Made with <span className="text-brand-500">❤️</span> by{" "}
            <a
              href="https://www.socialactive.gr/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-white/70 transition-colors hover:text-brand-300"
            >
              Social Active
            </a>
          </span>
          <span>VideoActive, Your Message Seen!</span>
        </div>
      </div>
    </footer>
  );
};
